<header>
  <app-layout-header (toggleMenu)="toggleMenu()" />
</header>
<main>
  <mat-sidenav-container>
    <mat-sidenav [opened]="open()" [mode]="mode()">
      <app-layout-menu (closeMenu)="closeMenu()" />
    </mat-sidenav>
    <mat-sidenav-content class="content">
      <div class="wrapper" role="presentation">
        <router-outlet />
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</main>
<footer>
  <app-layout-footer></app-layout-footer>
</footer>
